/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import ScheduleMeetingPopUp from "./ScheduleMeetingPopUp";

export default ScheduleMeetingPopUp;
